import { RichTextEditor } from '@/components/ui/RichTextEditor';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'richtext',
  renderInput: ({ field, value, onChange }) => (
    <RichTextEditor
      content={(value as string) || ''}
      onChange={(html) => onChange(html || null)}
      placeholder={`Wprowadź ${field.name.toLowerCase()}…`}
      minHeight="200px"
    />
  ),
  renderCell: (_field, value) => {
    if (!value) return '—';
    const stripped = String(value)
      .replace(/<[^>]*>/g, '')
      .trim()
      .slice(0, 100);
    return (
      <span className="text-sm text-text-primary" title={stripped}>
        {stripped}
        {stripped.length >= 100 ? '…' : ''}
      </span>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    const rules = (field.validationRules ?? {}) as Record<string, unknown>;
    const plain = String(value).replace(/<[^>]*>/g, '');
    if (rules['maxLength'] && plain.length > Number(rules['maxLength']))
      return `Maksimum ${rules['maxLength']} znaków`;
    return null;
  },
  defaultValue: '',
});
